import React, { useState } from 'react'
import { Alert, AlertTitle, Button, CircularProgress, DialogActions, DialogContent, DialogTitle, Divider, IconButton, List, ListItem, ListItemText, Snackbar } from '@mui/material';
import axios from "axios"
import { Auth } from "aws-amplify";
import { useTranslation } from "react-i18next";

import CloseIcon from '@mui/icons-material/Close';
import WarningIcon from '@mui/icons-material/Warning';

function DeleteStudent({ handleClose, studentData }) {
  const [toastOpen, setToastOpen] = useState(false);
  const [toastType, setToastType] = useState([]);
  const [deleteState, setDeleteState] = useState(false);

  const { t } = useTranslation()

  const deleteStudent = async (testId, studId) => {

    Auth.currentSession()
    .then(async (data) => {
      const jwtToken = data.idToken.jwtToken;
      const adminId = data.idToken.payload["custom:db_id"]

      try {
        const deleteResponse =  await axios.delete("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/admin/"+adminId+"/students?testId="+testId+"&studId="+studId, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
          }
        });
        // console.log("Upload Response: ",deleteResponse.data)
        if(deleteResponse.data === "Deletion Successful!") {
          alert(t("admin.students.deleteStudentDialogue.info_deleteSuccess"));
          setToastType(["success", "Deleted Student Entry Successfully!"])
          window.location.reload()
        }
        else if(deleteResponse.data === "Not Allowed to delete student entry when recordings exist in database."){
          alert(t("admin.students.deleteStudentDialogue.info_deleteCancelled"))
          setToastType(["error", "Deletion Aborted!"])
        }
        else{
          alert("Deletion Cancelled: \n"+deleteResponse.data)
          setToastType(["error", deleteResponse.data])
        }
        setToastOpen(true)
        setDeleteState(false)
      }
      catch (error) {
        console.log(error)
        setToastType(["error", t("commonItems.error_api_generic")])
        setToastOpen(true)
        setDeleteState(false)
      }
    })
    .catch((err) => console.log(err));
  };

  const handleToastClose = (event, reason) => {
    if (reason === 'clickaway') return
    setToastOpen(false);
  };

  const handleDelete = () => {
    if(!studentData.test){
      alert(t("commonItems.error_testNotStarted"))
      return
    }

    setDeleteState(true)
    deleteStudent(studentData.test.testId, studentData.studId)
  }

  return (
    <>
      <Snackbar open={toastOpen} autoHideDuration={5000} onClose={handleToastClose}>
        <Alert onClose={handleToastClose} severity={toastType[0]} sx={{ width: '100%' }}>
        {toastType[1]}
        </Alert>
      </Snackbar>
      <DialogTitle sx={{display: "flex", alignItems: "center", gap: "0.5rem"}}>
        <WarningIcon color="error" sx={{fontSize: "1.25rem"}}/>
        <b>{t("admin.students.deleteStudentDialogue.title")}</b>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8
        }}
      >
        <CloseIcon />
      </IconButton>
      {false ? 
        <>
          <DialogContent>
              <Alert severity="warning" className="uploadInstructions">
                <AlertTitle><b>{t("commonItems.info_featureNotAvailable")}</b></AlertTitle>
              </Alert>
          </DialogContent>
          <DialogActions>
            <Button color="info" variant="contained" onClick={handleClose}>{t("commonItems.buttonLabel_close")}</Button>
          </DialogActions>
        </>
      :
        <>
          {(studentData.test && studentData.test.superAdminId===24) ?
            <>
              <DialogContent>
                <Alert severity="info">
                  <AlertTitle><b>{t("admin.students.deleteStudentDialogue.info_KVStudentDelete")}</b></AlertTitle>
                </Alert>
              </DialogContent>
              <DialogActions>
                <Button color="info" variant="contained" onClick={handleClose}>{t("commonItems.buttonLabel_close")}</Button>
              </DialogActions>
            </>
          :
            <>
              <DialogContent dividers>
                <div className='deleteStudent' style={{display: "flex", flexDirection: "column", gap: "1rem"}}>
                  {(studentData.test ? studentData.test.status===0 : false) 
                    ?
                      <>
                        <div className="deleteStudentDetails" style={{display: "flex", gap:"1rem", backgroundColor: "#F1F3F9", borderRadius: "10px", padding: "1rem"}}>
                          <div style={{display: "flex", flexDirection: "column", flex: "0.7", gap: "0.5rem"}}>
                            <h4>{t("commonItems.textLabel_studentBasicDetails")}:</h4>
                            <p>{t("commonItems.textLabel_studentName")}: <b style={{fontWeight: 600}}>{studentData.studentName}</b></p>
                            <p>{t("commonItems.textLabel_gender")}: <b style={{fontWeight: 600}}>{studentData.gender}</b></p>
                            <p>{t("commonItems.textLabel_orgStudId")}: <b style={{fontWeight: 600}}>{studentData.orgStudId}</b></p>
                          </div>
                          <Divider orientation="vertical" flexItem/>
                          <div style={{display: "flex", flexDirection: "column", gap: "0.5rem"}}>
                            <h4>{t("commonItems.textLabel_classDetails")}:</h4>
                            <p>{t("commonItems.textLabel_class")}: <b style={{fontWeight: 600}}>{studentData.std}</b></p>
                            <p>{t("commonItems.textLabel_section")}: <b style={{fontWeight: 600}}>{studentData.divn}</b></p>
                            <p>{t("commonItems.textLabel_rollNo")}: <b style={{fontWeight: 600}}>{studentData.rollNo}</b></p>
                          </div>
                        </div>
                        <div>
                          <h4 style={{paddingBottom: "0.5rem"}}>{t("admin.students.deleteStudentDialogue.instructions_title")}</h4>
                          {/* <List dense disablePadding sx={{listStyleType: "decimal", listStylePosition: "inside"}}>
                            <ListItem disableGutters>
                              <ListItemText primary={<p>1. If any recordings of above student have already been uploaded from the TARA App, you will not be able to delete the student.</p>}/>
                            </ListItem>
                          </List>
                          <h4 style={{padding: "0.5rem 0"}}>If you still wish to proceed,</h4> */}
                          <List dense disablePadding sx={{listStyleType: "decimal", listStylePosition: "inside"}}>
                            <ListItem disableGutters>
                              <ListItemText primary={<p>{t("admin.students.deleteStudentDialogue.instructions_line1")}</p>}/>
                            </ListItem>
                            <ListItem disableGutters>
                              <ListItemText primary={<p>{t("admin.students.deleteStudentDialogue.instructions_line2")}</p>}/>
                            </ListItem>
                          </List>
                        </div>
                      </>
                    :
                      <Alert severity="error">
                        <AlertTitle><b>{t("admin.students.deleteStudentDialogue.error_editNotAllowed")}</b></AlertTitle>
                      </Alert>
                  }
                </div>
              </DialogContent>
              <DialogActions>
                {(studentData.test ? studentData.test.status===0 : false) 
                ? 
                <>
                    <h4 style={{marginRight: "auto", paddingLeft: "1rem", fontSize: "14px"}}>{t("admin.students.deleteStudentDialogue.footer")}</h4>
                    <Button color="info" variant="contained" onClick={handleClose}>{t("admin.students.deleteStudentDialogue.buttonLabel_cancel")}</Button>
                    {deleteState 
                      ?
                      <Button color="error" variant="contained" disabled>{t("admin.students.deleteStudentDialogue.buttonLabel_delete")}<CircularProgress size="1rem" color="inherit" sx={{marginLeft: "0.25rem"}}/></Button>
                      :
                      <Button color="error" variant="contained" onClick={handleDelete}>{t("admin.students.deleteStudentDialogue.buttonLabel_delete")}</Button>
                    }
                  </>
                :
                  <Button color="info" variant="contained" onClick={handleClose}>{t("commonItems.buttonLabel_close")}</Button>
                }
              </DialogActions>
            </>
          }
        </>
      }
    </>
  )
}

export default DeleteStudent